import { authConstants } from "../Constants";

const login = (auth) => {
	return {
		type: authConstants.LOGIN_SUCCESS,
		payload: auth
	}
}

const logout = () => {
	return {
		type: authConstants.LOGOUT,
	}
}

export const authActions = {
	login,
	logout
};